module.exports = __webpack_public_path__ + "static/media/create-profile.32f3a90e.svg";